import { segmentsAfter } from '../../components/FrostedGate/module-path';
import { ROUTES } from '../../constants/RouteNameMapping';
import { DealBoardDealCategory } from '../../types';

export type PipelinePreviewScreen =
  | { kind: 'board' }
  | { kind: 'category'; category: string }
  | { kind: 'analyticsKpis' }
  | { kind: 'analyticsDuration' };

/** The Pipeline screen a frosted module imitates at this path; the active-deals board is the landing page. */
export function pipelinePreviewScreen(pathname: string): PipelinePreviewScreen {
  const [section, sub] = segmentsAfter(pathname, ROUTES.DEAL_FLOW);

  if (section === ROUTES.DEAL_ANALYTICS) {
    return sub === ROUTES.DEAL_ANALYTICS_DURATION_DETAILS
      ? { kind: 'analyticsDuration' }
      : { kind: 'analyticsKpis' };
  }
  if (section === ROUTES.DEALS && sub && sub !== DealBoardDealCategory.CURRENT) {
    return { kind: 'category', category: sub };
  }
  return { kind: 'board' };
}
